import type { FaireProductEntity } from "../../entity_types/product";

export const p_jyaueyuxfa: FaireProductEntity = {
  token: "p_jyaueyuxfa",
  type: "product",
  name: "Kate Hoops in Tortoise Checker",
  brandToken: "b_dzjqqxzc",
  brandName: "MACHETE",
  imageUrl:
    "https://cdn.faire.com/fastly/092ea9315231c2fb5a1a28ca93db1017cbe54d28191cc9a1bb94389ded2fe6e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b9c054574f8b6178ffee48a0386c700c91775f42de85ed50d558562cc1d5a43.jpeg",
    "https://cdn.faire.com/fastly/10fdbd203268f5164cea3c4bc978600bf476df0c75713815e046b78d4413b755.jpeg",
    "https://cdn.faire.com/fastly/9a4b892e24ffca90205be68bfd8a0258379878cdec4f11869ec3f05f0bc3df35.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "\nOur signature open hoop earrings, handcrafted from lightweight Italian acetate with barrel backings.\n\n- Handmade from fine Italian acetate\n- Hypoallergenic stainless steel posts and logo-engraved backings\n- Approximately 1.5” inches in diameter\n",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:41.777Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
